import type { TOC } from '@ember/component/template-only';
import { PrismButton, PrismTooltip } from '@mylighthouse/prism-ember';
import { ICONS_LOGOS_MAP } from '@mylighthouse/prism-logo';
import { t } from 'ember-intl';
import { FocusScreen } from 'frontend-utils';
import SmartCompsetBuilderCategoriesIllustration from 'lumen/assets/images/benchmark-insight/smart-compset/beni-smart-compset-builder-categories.svg?raw';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderAiSuggestions from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-ai-suggestions';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderCategory from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-category';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-footer';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-header';
import HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo from 'lumen/components/hotel/benchmark-insight/competitors/smart-compset/smart-compset-builder/smart-compset-builder-info';
import type HotelSettingsCompetitorsBenchmarkSmartCompsetCategoriesController from 'lumen/controllers/hotel/settings/competitors/benchmark/smart-compset/categories';

interface HotelSettingsCompetitorsBenchmarkSmartCompsetCategoriesSignature {
  Args: {
    controller: HotelSettingsCompetitorsBenchmarkSmartCompsetCategoriesController;
    model: unknown;
  };
}

<template>
  <FocusScreen
    @hasCancel={{true}}
    @isCancelDisabled={{false}}
    @logoHtml={{ICONS_LOGOS_MAP.logo-dark-with-text}}
    @onClose={{@controller.onCloseModal}}
    @size="large"
  >
    <:header>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderHeader
        @currentStep={{1}}
      />
    </:header>

    <:body>
      <div class="smart-compset__builder__body">
        <div class="smart-compset__builder__body__left">
          <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderInfo
            @imageHtml={{SmartCompsetBuilderCategoriesIllustration}}
            @subTitle={{t
              "benchmark-insight.smart-compset.smart-compset-builder.sub-title.categories"
            }}
            @title={{t
              "benchmark-insight.smart-compset.smart-compset-builder.title.categories"
            }}
          />
        </div>
        <div class="smart-compset__builder__body__right">
          <div class="smart-compset__builder__body__right__content">
            <div
              class="smart-compset__builder__body__right__content__categories"
            >
              {{#each @controller.categories as |category|}}
                <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderCategory
                  @category={{category}}
                  @toggleCategory={{@controller.toggleCategory}}
                />
              {{/each}}
            </div>

            <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderAiSuggestions
              @headerText={{t
                "benchmark_insight.smart-compset.builder.categories.ai-suggestions.header"
              }}
              @suggestions={{@controller.aiSuggestions}}
            />
          </div>
        </div>
      </div>
    </:body>

    <:footer>
      <HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter
      >
        <span class="smart-compset__builder__footer--continue">
          <PrismButton
            @buttonType="brand"
            @iconAfter="arrow-right"
            @isDisabled={{@controller.isContinueDisabled}}
            @label={{t "general.continue"}}
            @onClick={{@controller.onContinue}}
            data-test-id="smart-compset-categories-button-continue"
          />

          {{#if @controller.isContinueDisabled}}
            <PrismTooltip
              @side="top"
              @text={{t "benchmark_insight.smart-compset.builder.continue"}}
            />
          {{/if}}
        </span>
      </HotelBenchmarkInsightCompetitorsSmartCompsetSmartCompsetBuilderSmartCompsetBuilderFooter>
    </:footer>
  </FocusScreen>
</template> satisfies TOC<HotelSettingsCompetitorsBenchmarkSmartCompsetCategoriesSignature>;
